"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localize = void 0;
var tslib_1 = require("tslib");
var determineAvailableLocaleCode = function (locale, localizations) {
    var _a = tslib_1.__read(locale.split("_"), 2), lang = _a[0], locality = _a[1];
    if (!localizations || lang === "en") {
        return;
    }
    var stringLocalizationKeys = Object.keys(localizations);
    var variants = stringLocalizationKeys.filter(function (key) { return lang === key.split("_")[0]; });
    if (variants.length == 1) {
        return variants[0];
    }
    else if (variants.length > 1) {
        var localityVariants = stringLocalizationKeys.filter(function (key) { return locality === key.split("_")[1]; });
        if (localityVariants.length == 1) {
            return localityVariants[0];
        }
        else {
            console.warn("Unable to determine locale for \"".concat(locale, "\""));
        }
    }
};
var Localize = (function () {
    function Localize() {
    }
    Localize.addTemplates = function (templates) {
        Object.keys(templates).forEach(function (k) { return Localize.templates.set(k, templates[k]); });
    };
    Localize.get = function (key, fallback, locale) {
        if (locale === void 0) { locale = Localize.defaultLocale; }
        var translation = this.templates.get(key);
        if (translation === null || translation === void 0 ? void 0 : translation.localizations) {
            var localeValue = determineAvailableLocaleCode(locale, translation.localizations);
            if (localeValue) {
                var translationValue = translation.localizations[localeValue];
                if (translationValue) {
                    return translationValue;
                }
            }
        }
        return (translation === null || translation === void 0 ? void 0 : translation.default) || fallback || key;
    };
    Object.defineProperty(Localize, "defaultLocale", {
        get: function () {
            if (!Localize._defaultLocale) {
                Localize._defaultLocale = (function (el) {
                    if (el) {
                        var _a = tslib_1.__read(el.split("-"), 2), lang = _a[0], locality = _a[1];
                        if (locality) {
                            return "".concat(lang, "_").concat(locality.toLocaleUpperCase());
                        }
                        return "".concat(lang, "_").concat(lang.toUpperCase());
                    }
                    return "en_US";
                })(window === null || window === void 0 ? void 0 : window.navigator.language);
            }
            return Localize._defaultLocale;
        },
        set: function (value) {
            Localize._defaultLocale = value;
        },
        enumerable: false,
        configurable: true
    });
    Localize.templates = new Map();
    return Localize;
}());
exports.Localize = Localize;
//# sourceMappingURL=Localize.js.map